import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Container = lib.styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  flex-direction: column;
  background-color: rgb(32,33,36)!important;
  overflow: hidden!important;
  flex: 1;
`;

export const Header = lib.styled.div`
  display: flex;
  align-items: center;
  padding: 15px 15px 0 20px;
  width: 100%;
  height: 50px;
`;

export const VideoContainer = lib.styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 10px 20px 20px 20px;
`;

export const CallControlContainer = lib.styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 70px;
  background-color: ${colors.white02};
`;

export const BetaMessage = lib.styled.div`
  display: flex;
  position: absolute;
  top: 5px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 3px;
  border-radius: 5px;
  min-width: 380px;
  z-index: 999;

  span {
    font-size: 14px;
  }
`;

export const GenericMessage = lib.styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  background: ${colors.white};
  padding: 15px 20px 15px 20px;
  border-radius: 5px;
  min-width: 250px;
  margin-top: -200px
`;
